import React from "react";
import Layout from "./../components/Layout/Layout";
import { Helmet, HelmetProvider } from "react-helmet-async";
import AboutSection from "./AboutSection";
import OfferSection from "./OfferSection";

const About = () => {
  return (
    <Layout>
      <HelmetProvider>
        <Helmet>
          <title>Finkoda | About us</title>
          <meta name="description" content="Financial information to help you make informed decisions, manage assets, and plan for a secure future." />
          <meta name="keywords" content="financial information, investments, money management, personal finance, financial planning, wealth management, financial advice, banking, budgeting, financial goals" />
          <link rel="canonical" href="https://finkoda.com/about" />
          <link rel="alternate" media="only screen and (max-width: 640px)" href="https://finkoda.com/about" />
          <meta property="og:type" content="website" />
          <meta property="og:title" content="Finkoda | About us" />
          <meta property="og:url" content="https://finkoda.com/about" />
          <meta property="og:image" content="%PUBLIC_URL%/logo.png" />
          <meta property="og:description" content="Financial data to support your asset management, future planning, and well-informed decision-making." />

          {/* Twitter */}
          <meta name="twitter:card" content="summary" />
          <meta name="twitter:title" content="Finkoda | About us" />
          <meta name="twitter:site" content="@Finkoda" />
          <meta name="twitter:description" content="Financial data to support your asset management, future planning, and well-informed decision-making." />
          <meta name="twitter:image" content="%PUBLIC_URL%/logo.png" />
          <meta name="twitter:image:alt" content="Finkoda" />


        </Helmet>
      </HelmetProvider>

      <AboutSection />
      <OfferSection />


    </Layout>
  );
};

export default About;
